import CasinoPage from "@/pages/casinoLayout.tsx";

export default function Index() {
  return <CasinoPage />;
}
